import { stripNonMatching } from '@tectonics/utils/formatting';
import type { Maybe } from '@tectonics/utils/types';

const getPhoneNumberNormalizerWithLength = (length: number) => (phoneNumber: Maybe<string>): string => {
  if (!phoneNumber) {
    return '';
  }

  return stripNonMatching(phoneNumber, 'numeric').slice(0, Math.max(0, length));
};

export { getPhoneNumberNormalizerWithLength };
